import { render, staticRenderFns } from "./Undelivered.vue?vue&type=template&id=72bdf852&"
import script from "./Undelivered.vue?vue&type=script&lang=js&"
export * from "./Undelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports